import {Directive, Input} from '@angular/core';
import {UntypedFormControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  selector: '[appCustomMax][formControlName],[appCustomMax][formControl],[appCustomMax][ngModel]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomMaxDirective, multi: true}],
  standalone: false
})
export class CustomMaxDirective implements Validator {
  @Input()
  appCustomMax: number;

  validate(c: UntypedFormControl): ValidationErrors | null {
    return c.value > this.appCustomMax ? {max: {messageKey: 'Max Validation Message', parameters: {value: this.appCustomMax}}} : null;
  }
}

